import {Button, Card, CardBody, Input,} from "@material-tailwind/react";
import React, {useState} from "react";
import {countTaskResult} from "../../api/MessageAPI";
import Chart from 'react-apexcharts'

export default function TaskMonitor() {

  const [taskId, setTaskId] = useState('9ca072b4-f01b-4495-a669-5ae8ad98778a');
  const [taskResult, setTaskResult] = useState([]);

  const taskChart = {
    options: {
      chart: {
        type: "donut",
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          donut: {
            size: "80%",
          },
        },
      },
      fill: {
        colors: ["#00D1FF", "#ff7777", '#FFEC36'],
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val) {
            return val
          },
          title: {
            formatter: function (seriesName) {
              return "";
            },
          },
        },
      },
    },
    series: []
  }

  const handleSearch = (e) => {
    e.preventDefault()
    countTaskResult(taskId)
      .then(res => {
        if (res.data.resultCode === 0) {
          Object.entries(res.data.data).forEach(([round, roundVal]) => {
            if ("TRAINING" in roundVal) {
              setTaskResult(prev => [...prev, {"round": round, "jobType": "TRAINING", "result": roundVal["TRAINING"]}])
            }
            if ("EVALUATION" in roundVal) {
              setTaskResult(prev => [...prev, {
                "round": round,
                "jobType": "EVALUATION",
                "result": roundVal["EVALUATION"]
              }])
            }
            if ("TEST" in roundVal) {
              setTaskResult(prev => [...prev, {"round": round, "jobType": "TEST", "result": roundVal["TEST"]}])
            }
          })

        } else {
          alert("Result code is fail!")
          console.log(res)
        }
      })
      .catch(err => console.log(err))
  }

  const parseChartValue = (e) => {
    let init = e['Init'] !== undefined ? e['Init'] : 0
    let success = e['Success'] !== undefined ? e['Success'] : 0
    let fail = e['Fail'] !== undefined ? e['Fail'] : 0
    let notSend = init - success - fail

    return {
      'init': init,
      'success': success,
      'fail': fail,
      'notSend': notSend,
    }
  }

  return (
    <>
      <form className="mb-5" onSubmit={handleSearch}>
        <div className="flex">
          <div className={"w-96"}>
            <Input
              label="Task ID"
              defaultValue={taskId}
              onChange={e => setTaskId(e.target.value)}
            />
          </div>
          <Button
            color={"cyan"}
            className="flex items-center gap-2 rounded-full ml-3"
            onClick={handleSearch}
          >
            Search
          </Button>
        </div>
      </form>

      <div className="grid grid-cols-2 2xl:grid-cols-4 gap-4">
        {
          taskResult.map((item, idx) => {
            let chartValue = parseChartValue(item["result"])
            return <div className='flex gap-4' key={idx}>
              {
                <Card className="mt-6 w-96" key={idx}>
                  <div className="w-full mt-3 text-center text-3xl">
                    {item["round"]} Round - {item["jobType"]}
                  </div>
                  <CardBody className='pt-5'>
                    <div className="relative">
                      <Chart
                        options={taskChart.options}
                        series={[chartValue['success'], chartValue['fail'], chartValue['notSend']]}
                        type="donut"/>
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <div className='font-bold'>
                          <div className='text-blue-gray-400'>
                            Total : {chartValue['init']} <br/>
                          </div>
                          <div className='text-[#00D1FF]'>
                            Success : {chartValue['success']} <br/>
                          </div>
                          <div className='text-[#ff7777]'>
                            Fail : {chartValue['fail']} <br/>
                          </div>
                          <div className='text-[#FFEC36]'>
                            Not send : {chartValue['notSend']}
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>

              }
            </div>
          })
        }
      </div>
    </>
  )
}
